module.exports = __webpack_public_path__ + "media/images/hortense-for-wedding/piscine-f6744eb13401c0bd7d0b4e0aee6e67cb.png";